// Danske UI-tekster – kilden til alle sprog. Flade nøgler grupperet efter skærm: '<skærm>.<navn>'.
// en.ts (og senere sprog) skal have præcis de samme nøgler; tsc fejler ellers.
// {navn} erstattes af t('nøgle', { navn: … }). Banernes og verdenernes navne står i src/worlds/<key>/strings.ts.
export const da = {
  'app.name': 'Mekaniko',

  // Knapper uden tekst (skærmlæser): index.html (data-i18n-aria) og koden
  'aria.map': 'Kort',
  'aria.howTo': 'Se hvordan',
  'aria.hint': 'Hjælp',
  'aria.start': 'Start',
  'aria.rotateLeft': 'Drej venstre',
  'aria.rotateRight': 'Drej højre',
  'aria.remove': 'Fjern',
  'aria.switchPlayer': 'Skift spiller',
  'aria.retry': 'Prøv igen',
  'aria.nextLevel': 'Næste bane',
  'aria.credits': 'Rulletekster',
  'aria.ok': 'OK',
  'aria.back': 'Tilbage',
  'aria.close': 'Luk',
  'aria.playWorld': 'Spil',
  'aria.player': 'Spiller {n}',
  'aria.newPlayer': 'Ny spiller',
  'aria.changeClothes': 'Skift tøj',
  'aria.level': 'Bane {n}',

  // Betalingsmur og forældre-port
  'gate.adults': 'Til voksne',
  'gate.help': 'Til voksne: vælg det rigtige svar',

  // Forældrepanel
  'parent.title': 'Forældre & lærere',
  'parent.intro': 'Mekaniko træner teknisk forståelse: barnet bygger, afprøver og justerer små maskiner. Det er den designproces, natur/teknologi arbejder med i indskolingen.',
  'parent.progress': 'Fremskridt',
  'parent.player': 'Spiller',
  'parent.stars': 'Stjerner',
  'parent.levels': 'Baner',
  'parent.ducks': 'Ænder',
  'parent.none': 'Ingen spillere endnu.',
  'parent.reset': 'Slet spiller',
  'parent.goalsTitle': 'Det træner spillet',
  'parent.goalsNote': 'Koblet til Fælles Mål for natur/teknologi efter 2. klasse: “undersøge, hvordan enkle mekanismer fra hverdagen fungerer” og “deltage i designprocesser”. Grønt flueben = barnet har klaret en bane med emnet.',
  'parent.settings': 'Indstillinger',
  'parent.hintAlways': 'Hjælpe-knappen er altid synlig',
  'parent.hintAlwaysNote': 'Ellers dukker den op, når barnet har prøvet 3 gange uden at lykkes.',
  'parent.sound': 'Lydeffekter',
  'parent.music': 'Musik',
  'parent.language': 'Sprog',
  'parent.testAll': 'Testtilstand: alle baner åbne',
  'parent.testAllNote': 'Til dig som udvikler — slå fra igen før spillet vises til andre.',
  'parent.credits': 'Rulletekster',
  'parent.buyTitle': 'Hele spillet',
  'parent.buyText': 'De første 3 baner er gratis. Køb én gang og lås alle baner og verdener op. Ingen reklamer, ingen køb inde i spillet.',
  'parent.buyBtn': 'Lås op (demo)',
  'parent.bought': 'Låst op ✓',
  'parent.buyNote': 'Prototype: der sker ikke noget rigtigt køb.',

  // Læringsmål (learn-tags i banerne) – vises i forældrepanelet
  'goal.gravity': 'Tyngdekraft: ting falder og ruller nedad',
  'goal.ramp': 'Skråplan og ramper',
  'goal.direction': 'En kraft kan ændre retning',
  'goal.spring': 'Fjedre og elasticitet',
  'goal.lever': 'Vægtstang (vippe)',
  'goal.friction': 'Friktion: overflader bremser',
  'goal.materials': 'Materialers egenskaber',
  'goal.energy': 'Energi omdannes (fald → hop)',
  'goal.mechanism': 'Enkle mekanismer fra hverdagen',
  'goal.chain_reaction': 'Årsag og virkning (kædereaktion)',
  'goal.counting': 'Tælle og antal (matematik)',
  'goal.pulley': 'Trisse og løft',
  'goal.weight': 'Tung og let (masse)',

  // Rulletekster
  'credits.map': 'Kortet',
  'credits.music': 'Musik',
  'credits.note': 'Musikken er fra Pixabay. Tak til kunstnerne!',
  'credits.thanks': 'Tak til',
};
